import styles from "../css/project.module.css";
import modesens from "../media/modesens.png";
import travelocity from "../media/travelocity.png";
import everhour from "../media/everhour.png";
import rentomojo from "../media/rentomojo.png";
import LinkIcon from "@mui/icons-material/Link";
import GitHubIcon from "@mui/icons-material/Link";
import vowelweb from "../media/vowelweb.png";
import chatapp from "../media/chatapp.png";
import GithubStat from "./Github";
export const Project = () => {
  return (
    <div id="projects" className={styles.container}>
      <h1 className={styles.heading}>Projects</h1>
      <div className={styles.childs}>
        <div>
          <center>
            <img style={{ borderRadius: "5px" }} src={chatapp} alt="" />
          </center>
        </div>
        <div>
          <h1 style={{fontSize:"20px"}}>Real-Time-Chat-App</h1>
          <div className={styles.afterImg}>
            Real-Time-Chat-App is Replica of one of the biggest social media
            platform Whats-up , in my version of whats-up you can do everything
            from signing up to talking to friends updating profile photo , many
            more such features all built solely by me .
          </div>
          <div className={styles.afterImg2}>
            Tech stack- React | Socket.io | Node js | Express js | MongoDB |
            Chakra UI
          </div>
          <br />
          <div className={styles.icon}>
            {/* <button
              onClick={() => {
                window.open(
                  "https://rentify-khadsepranay.vercel.app/",
                  "_blank"
                );
              }}
            >
              <LinkIcon />
              Website
            </button> */}
            <button
              onClick={() => {
                window.open(
                  "https://github.com/Vicky160898/Real-Time-Chat-App",
                  "_blank"
                );
              }}
            >
              <GitHubIcon />
              GitHub
            </button>
          </div>
        </div>
      </div>
      <div className={styles.childs}>
        <div>
          <center>
            <img style={{ borderRadius: "5px" }} src={rentomojo} alt="" />
          </center>
        </div>
        <div>
          <h1 style={{fontSize:"20px"}}>Rentomojo.com</h1>
          <div className={styles.afterImg}>
            India's leading rental platform brings to you a wide range of
            products on rent. Rento mojo is an online rental platform that
            provides furniture, appliances and electronics on a monthly rental
            basis.
          </div>
          <div className={styles.afterImg2}>
            Tech stack- React | Redux | Node js | Express js | MongoDB | Chakra
            UI
          </div>
          <br />
          <div className={styles.icon}>
            <button
              onClick={() => {
                window.open(
                  "https://rentify-khadsepranay.vercel.app/",
                  "_blank"
                );
              }}
            >
              <LinkIcon />
              Website
            </button>
            <button
              onClick={() => {
                window.open(
                  "https://github.com/khadsepranay/Rentify.com",
                  "_blank"
                );
              }}
            >
              <GitHubIcon />
              GitHub
            </button>
          </div>
        </div>
      </div>
      <div className={styles.childs}>
        <div>
          <center>
            <img style={{ borderRadius: "5px" }} src={vowelweb} alt="" />
          </center>
        </div>
        <div>
          <h1 style={{fontSize:"20px"}}>VowelWeb.in</h1>
          <div className={styles.afterImg}>
            It is an e-commerce website used to buy and supply cloths and beauty
            products worldwide. here I have implemented the actual payment
            gateway and there is also Admin panel where admin can add, delete
            and edit the product.
          </div>
          <div className={styles.afterImg2}>
            Tech stack- React | Node js | Express js | MongoDB | Razorpay |
          </div>
          <br />
          <div className={styles.icon}>
            <button
              onClick={() => {
                window.open(
                  "https://vowelweb-vicky160898.vercel.app/login",
                  "_blank"
                );
              }}
            >
              {" "}
              <LinkIcon />
              Website
            </button>
            <button
              onClick={() => {
                window.open(
                  "https://github.com/Vicky160898/vowelWEB-MERN",
                  "_blank"
                );
              }}
            >
              <GitHubIcon />
              GitHub
            </button>
          </div>
        </div>
      </div>
      <div className={styles.childs}>
        <div>
          <center>
            <img style={{ borderRadius: "5px" }} src={everhour} alt="" />
          </center>
        </div>
        <div>
          <h1 style={{fontSize:"20px"}}>Zee5.com</h1>
          <div className={styles.afterImg}>
            This is A Clone Of Zee5 Which is A OTT Application To watch movies
            and web-series online this is Full-Stack Project With Backend Code
            Including Admin Side Also
          </div>
          <div className={styles.afterImg2}>
            Tech stack- Next js | Chakra Ui | MongoDB | express js | Node js
          </div>
          <br />
          <div className={styles.icon}>
            <button
              onClick={() => {
                window.open("https://temporary-bag-6678.vercel.app", "_blank");
              }}
            >
              <LinkIcon />
              Website
            </button>
            <button
              onClick={() => {
                window.open("https://github.com/Vicky160898/Zee5", "_blank");
              }}
            >
              {" "}
              <GitHubIcon />
              GitHub
            </button>
          </div>
        </div>
      </div>
      <div className={styles.childs}>
        <div>
          <center>
            <img style={{ borderRadius: "5px" }} src={travelocity} alt="" />
          </center>
        </div>
        <div>
          <h1 style={{fontSize:"20px"}}>Travelocity.com</h1>
          <div className={styles.afterImg}>
            Travelocity is one of the fastest growing online travel & Resort
            portals in Asia, a comprehensive offering of flight inventory made
            available on the website, travellers can book rooms to meet every
            budget and travel services to complement.
          </div>
          <div className={styles.afterImg2}>Tech stack- HTML | CSS | Git</div>
          <br />
          <div className={styles.icon}>
            <button
              onClick={() => {
                window.open(
                  "https://travelocity-ruby.vercel.app/index.html",
                  "_blank"
                );
              }}
            >
              <LinkIcon />
              Website
            </button>
            <button
              onClick={() => {
                window.open(
                  "https://github.com/Vicky160898/Travelocity.com",
                  "_blank"
                );
              }}
            >
              <GitHubIcon />
              GitHub
            </button>
          </div>
        </div>
      </div>

      <div className={styles.childs}>
        <div>
          <center>
            <img style={{ borderRadius: "5px" }} src={modesens} alt="" />
          </center>
        </div>
        <div>
          <h1 style={{fontSize:"20px"}}>Modesens.com</h1>
          <div className={styles.afterImg}>
            It is an e-commerce website used to buy and supply cloths and beauty
            products worldwide. This was a team project where I with my
            teammates had created.My task was to do Login and Signup
            functionality with men and women product page and help in the css
            part.
          </div>
          <div className={styles.afterImg2}>
            Tech stack- JavaScript | HTML | CSS |
          </div>
          <br />
          <div className={styles.icon}>
            <button
              onClick={() => {
                window.open(
                  "https://dainty-begonia-81897f.netlify.app/",
                  "_blank"
                );
              }}
            >
              <LinkIcon />
              Website
            </button>
            <button
              onClick={() => {
                window.open(
                  "https://github.com/surya382/nutty-dinner-4204",
                  "_blank"
                );
              }}
            >
              <GitHubIcon />
              GitHub
            </button>
          </div>
        </div>
      </div>
      <GithubStat />
    </div>
  );
};
